import CoabalanceModel from '../coabalance/coabalance-model';
import OwnerModel from '../owner/owner-model';

export default class CoaModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    owner: any;
    ownerCaption: string;
    parent: any;
    parentCaption: string;
    coabalance: any;
    coabalanceLength: number;
    coabalanceValue: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'asset';
        this.typeCaption = CoaModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Asset';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name; 
        let parent= datarow.parent?.data? new CoaModel(datarow.parent?.data) : datarow.parent;
        this.parent= parent?.id;
        this.parentCaption = parent?.name;
        this.coabalance = datarow.coabalance?.data?.map((d: any) => new CoabalanceModel(d));
        this.coabalanceLength = this.coabalance?.length || 0;
        this.coabalanceValue = this.coabalance?.[this.coabalanceLength-1].value || 0;
        
    } 

    public static endPoint: string = 'coas';
    public static endPointFilterList = (parentId?: number) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true'));
    } 
    public static url: string = '/coa';
    public static caption: string = 'Chart of Account';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        type: 'asset',
        typeCaption: 'Asset',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
        parent: null,
        parentCaption: '',
        coabalance: [],
        coabalanceLength: 0,
        coabalanceValue: 0,
  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'coabalanceValue', caption: 'Last Balance', type: 'money' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'asset', caption: 'Asset' },
        { name: 'liability', caption: 'Liability' },
        { name: 'equity', caption: 'Equity' },
        { name: 'income', caption: 'Income' },
        { name: 'expense', caption: 'Expense' },
    ]
}